<template>
  <li class="kefu usermenu">
    <div style="display: flex; flex-direction: column; gap: 5px">
      <customer-service-outlined style="font-size: 20px; color: var(--text-color)" />
      <a-badge :count="chat_unread" :dot="true" :offset="[0, -20]" style="color: var(--text-color)">
        {{ $t('_db._zskf') }}
      </a-badge>
    </div>
    <div class="wrap-a1 popover popover-enter-to menubox">
      <!-- <ul class="tab">
        <li class="active">{{ $t('_h._lsjl') }}</li>
      </ul> -->
      <ul class="list drama_list column">
        <li class="wrapbg1" @click="onService">
          <CommentOutlined style="margin-right: 13px; font-size: 20px" />
          <a-badge :count="chat_unread" :offset="[100, 5]">
            <div class="KCBwR lcFyR tuUGG RTmqg" style="color: var(--text-color)">{{ $t('_db._zsry') }}</div>
          </a-badge>
        </li>
        <li class="wrapbg1" v-if="sp_info.whatsapp">
          <IconWhatsApp style="margin-right: 13px; font-size: 20px" />
          <div>Whats app</div>
          <a :href="sp_info.whatsapp ? 'https://wa.me/' + sp_info.whatsapp : 'javascript:'" :target="sp_info.whatsapp ? '_blank' : ''"> </a>
        </li>
        <li class="wrapbg1" v-if="sp_info.telegram">
          <IconTelegram style="margin-right: 13px; font-size: 20px" />
          <div>Telegram</div>
          <a :href="sp_info.telegram ? 'https://t.me/' + sp_info.telegram : 'javascript:'" :target="sp_info.telegram ? '_blank' : ''"> </a>
        </li>
        <li class="wrapbg1" v-if="sp_info.line">
          <IconLine style="margin-right: 13px; font-size: 20px" />
          <div>Line</div>
          <a :href="sp_info.line" :target="sp_info.line ? '_blank' : ''"> </a>
        </li>
        <li class="wrapbg1" v-else-if="sp_info.line_qrcode" style="position: relative">
          <IconLine style="margin-right: 13px; font-size: 20px" />
          <div>Line</div>
          <div class="lineerwm">
            <img :src="sp_info.line_qrcode + '?r_qrcode=' + parseInt(Math.random() * 1000)" alt="line" style="width: 100%" />
          </div>
        </li>
      </ul>
      <!-- <button class="more" @click="onMoreHistofy()">{{ $t('_h._gd') }}</button> -->
    </div>
  </li>
</template>

<script>
import { CommentOutlined, CustomerServiceOutlined } from '@ant-design/icons-vue'
export default {
  name: 'serviceVue',
  components: { CommentOutlined, CustomerServiceOutlined },
  props: ['chat_unread'],
  data() {
    return {
      sp_info: {}
    }
  },
  created() {
    let info = this.$common.getInfo()
    if (info) {
      this.sp_info = info.agent
      console.log(this.sp_info)
    }
  },
  methods: {
    onService() {
      this.$router.push({ name: 'service' })
    }
  }
}
</script>

<style></style>
